import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router'
import { HttpClient } from '@angular/common/http';
import { bmxurl, getAccess } from 'src/globals';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { cResourcereductions, resourcereductions } from 'src/types/resourcereductions';
import { resourcereductions_returndata } from 'src/types/resourcereductions_returndata';
import { users_returndata } from 'src/types/user_returndata';
import { GlobalService } from '../_services/global.service';
import { cResource } from 'src/types/resource';

//The Resource Reductions twin of resclosingsedit: same fields and the same save format,
//with "closing" read as "reduction", plus an adjustment that either sets a new capacity or
//reduces the current one (adjustmenttype NEWCAPACITY / REDUCEBY). Kept as its own component
//rather than a mode flag on the closing screen so the two can diverge without tangling.
@Component({
  selector: 'app-resreductionsedit',
  templateUrl: './resreductionsedit.component.html',
  styleUrls: ['./resreductionsedit.component.css']
})
export class ResreductionseditComponent implements OnInit {
  ResourceReduction: cResourcereductions;
  httpResponse: any;
  id: string;

  resourceNameValid: boolean = true;
  resourceStartDateValid: boolean = true;
  resourceEndDateValid: boolean = true;
  resourceDateLoginValid: boolean = true;
  resourceDaysValid: boolean = true;
  resourceChosenValid: boolean = true;
  adjustmentValid: boolean = true;

  resourceStartTimeHours: any[];
  resourceStartTimeMins: any[];

  resourceSelectedStartTimeHours: string;
  resourceSelectedStartTimeMins: string;

  resourceSelectedEndTimeHours: string;
  resourceSelectedEndTimeMins: string;

  pageReady: boolean = false;

  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;

  newStartDate: Date;
  newEndDate: Date;

  VenueID: string = localStorage.getItem("SmartVenueID")!;

  ResourceList: any[] = [];
  chosenResource: cResource = new cResource();

  //Capacity of the chosen resource (concurrentUses): the Reduce By ceiling, and the base the
  //resulting capacity is worked out from.
  resourceCapacity: number = 0;

  adjustmentTypeOptions = [
    {label: 'New Capacity', value: 'NEWCAPACITY'},
    {label: 'Reduce By', value: 'REDUCEBY'}
  ];

  //Mode the amount was last expressed in. A click on the option that is already selected
  //still fires onChange, and without this it would convert the amount a second time.
  currentAdjustmentType: string = 'REDUCEBY';

  stateOptions = [
    {label: 'Yes', value: true},
    {label: 'No', value: false}
  ];

  dayOptions = [
    {label: 'Monday', value: 'monday'},
    {label: 'Tuesday', value: 'tuesday'},
    {label: 'Wednesday', value: 'wednesday'},
    {label: 'Thursday', value: 'thursday'},
    {label: 'Friday', value: 'friday'},
    {label: 'Saturday', value: 'saturday'},
    {label: 'Sunday', value: 'sunday'}
  ];

  selectedDays: string[] = [];

  constructor(private route: ActivatedRoute, private http: HttpClient, private router: Router, private messageService: MessageService,private globalService: GlobalService) {
    this.ResourceReduction = {
      id: null,
      resourcereductionid: null,
      resourceid: null,
      name: "",
      resourcetoreduce: null,
      adjustmentamount: 0,
      adjustmenttype: 'REDUCEBY',
      disabled: false,
      venueid: this.VenueID,
      startdate: null,
      enddate: null,
      publicmessage: null,
      venuemessage: null,
      reductionbasedonday: false,
      monday: false,
      tuesday: false,
      wednesday: false,
      thursday: false,
      friday: false,
      saturday: false,
      sunday: false
    }

    this.resourceStartTimeHours = [
      {name: '00', code: '00'},
      {name: '01', code: '01'},
      {name: '02', code: '02'},
      {name: '03', code: '03'},
      {name: '04', code: '04'},
      {name: '05', code: '05'},
      {name: '06', code: '06'},
      {name: '07', code: '07'},
      {name: '08', code: '08'},
      {name: '09', code: '09'},
      {name: '10', code: '10'},
      {name: '11', code: '11'},
      {name: '12', code: '12'},
      {name: '13', code: '13'},
      {name: '14', code: '14'},
      {name: '15', code: '15'},
      {name: '16', code: '16'},
      {name: '17', code: '17'},
      {name: '18', code: '18'},
      {name: '19', code: '19'},
      {name: '20', code: '20'},
      {name: '21', code: '21'},
      {name: '22', code: '22'},
      {name: '23', code: '23'}
      ];

    this.resourceStartTimeMins = [
        {name: '00', code: '00'},
        {name: '05', code: '05'},
        {name: '10', code: '10'},
        {name: '15', code: '15'},
        {name: '20', code: '20'},
        {name: '25', code: '25'},
        {name: '30', code: '30'},
        {name: '35', code: '35'},
        {name: '40', code: '40'},
        {name: '45', code: '45'},
        {name: '50', code: '50'},
        {name: '55', code: '55'},
      ];

  }

  ngOnInit(): void {

    this.globalService.setSmallScreenMenu(false);

    let userid = localStorage.getItem("SmartUserID");

    this.http.get(bmxurl + "User/" + userid).subscribe(response => {
      this.httpResponse =  (response as users_returndata)
      if(this.httpResponse.succeeded)
      {
        let user = this.httpResponse.data;

        //No permission of its own yet - reductions sit on the Resource Closings screen, so
        //they share its RESOURCECLOSINGS access.
        if(getAccess("RESOURCECLOSINGS", user)){
          this.AccessAllowed = true;
          this.id = this.route.snapshot.paramMap.get('id');
          if(this.id != "0")
          {
            this.http.get(bmxurl + "resourcelist/" + this.VenueID).subscribe(response => {
              this.ResourceList = (response as any).data;
              this.pageReady = false;
              this.http.get(bmxurl + "ResourceReduction/" + this.VenueID + "/" + this.id).subscribe(response => {
                this.httpResponse = (response as resourcereductions_returndata)
                if (this.httpResponse.succeeded)
                {
                  //Whole object rather than the closing screen's field-by-field copy, so a
                  //field added to the API later is not silently dropped on the next save.
                  this.ResourceReduction = Object.assign(new cResourcereductions(), this.httpResponse.data);

                  if(this.ResourceReduction.adjustmenttype != 'NEWCAPACITY')
                    this.ResourceReduction.adjustmenttype = 'REDUCEBY';

                  this.currentAdjustmentType = this.ResourceReduction.adjustmenttype;

                  this.syncSelectedDaysFromModel();

                  this.getChosenResource();

                  this.newStartDate = new Date(Number(this.ResourceReduction.startdate.substring(0,4)), Number(this.ResourceReduction.startdate.substring(5,7)) - 1, Number(this.ResourceReduction.startdate.substring(8,10)));
                  this.newEndDate = new Date(Number(this.ResourceReduction.enddate.substring(0,4)), Number(this.ResourceReduction.enddate.substring(5,7)) - 1, Number(this.ResourceReduction.enddate.substring(8,10)));

                  this.resourceSelectedStartTimeHours = this.ResourceReduction.startdate.substring(11,13);
                  this.resourceSelectedStartTimeMins = this.ResourceReduction.startdate.substring(14,16);

                  this.resourceSelectedEndTimeHours = this.ResourceReduction.enddate.substring(11,13);
                  this.resourceSelectedEndTimeMins = this.ResourceReduction.enddate.substring(14,16);

                  this.pageReady = true;
                }
                else
                {
                  this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting Resource Adjustments'});
                  this.pageReady = false;
                }
              }, error => {
                this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting Resource Adjustments, error:' + error.messages[0]});
                this.pageReady = false;
              });
            });
          }
          else
          {
            this.http.get(bmxurl + "resourcelist/" + this.VenueID).subscribe(response => {
              if((response as any).succeeded)
              {
                this.ResourceList = (response as any).data;
              }
              else
              {
                this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting Resources'});
                this.pageReady = false;
              }
              }, error => {
                this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting Resources, error:' + error.messages[0]});
                this.pageReady = false;
              });

            this.pageReady = true;
          }
        }

        this.CompletedLoading = true;

      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting User, error:' + error.messages[0]});
    });

  }

  getChosenResource()
  {
    if(this.ResourceReduction.resourcetoreduce == null)
      return;

    this.ResourceList.forEach(element => {
      if(element.id == this.ResourceReduction.resourcetoreduce.id)
      {
        this.chosenResource = element;
      }
    });

    //No clamp on load: if the resource's capacity has dropped below a saved adjustment, the
    //save-time check reports it rather than the figure being quietly rewritten.
    this.setResourceCapacity();
  }

  setResourceCapacity()
  {
    let capacity = Number(this.chosenResource?.concurrentUses ?? 0);

    this.resourceCapacity = (isNaN(capacity) || capacity < 0) ? 0 : capacity;
  }

  //Upper limit for the amount in the current mode. Reduce By cannot take off more than the
  //resource has. New Capacity may go above the current figure, so it only gets the same
  //ceiling the resource screen puts on capacity itself.
  adjustmentMax(): number
  {
    return this.ResourceReduction.adjustmenttype == 'NEWCAPACITY' ? 100000 : this.resourceCapacity;
  }

  //The capacity the resource ends up with, for the hint under the spinner.
  resultingCapacity(): number
  {
    let amount = Number(this.ResourceReduction.adjustmentamount ?? 0);

    if(this.ResourceReduction.adjustmenttype == 'NEWCAPACITY')
      return amount;

    return this.resourceCapacity - amount;
  }

  clampAdjustment()
  {
    if(this.ResourceReduction.adjustmentamount == null || this.ResourceReduction.adjustmentamount < 0)
      this.ResourceReduction.adjustmentamount = 0;

    if(this.ResourceReduction.adjustmentamount > this.adjustmentMax())
      this.ResourceReduction.adjustmentamount = this.adjustmentMax();
  }

  //Choosing a different resource moves the Reduce By ceiling, so the amount is brought back
  //into range. The spinner [max] stops typing past it, but does not correct a figure that
  //was already higher than the new resource allows.
  onResourceChange()
  {
    this.setResourceCapacity();
    this.clampAdjustment();

    this.resourceChosenValid = true;
    this.adjustmentValid = true;
  }

  //Switching mode converts the amount so the outcome stays the same: reducing 10 by 3 becomes
  //a new capacity of 7, and back again - capacity minus amount works in both directions. A
  //new capacity above the current one has no Reduce By equivalent, so it clamps to 0.
  onAdjustmentTypeChange()
  {
    if(this.ResourceReduction.adjustmenttype == this.currentAdjustmentType)
      return;

    let amount = Number(this.ResourceReduction.adjustmentamount ?? 0);

    this.ResourceReduction.adjustmentamount = this.resourceCapacity - amount;
    this.currentAdjustmentType = this.ResourceReduction.adjustmenttype;

    this.clampAdjustment();
    this.adjustmentValid = true;
  }

  syncSelectedDaysFromModel()
  {
    this.selectedDays = [];

    if(this.ResourceReduction.monday) this.selectedDays.push('monday');
    if(this.ResourceReduction.tuesday) this.selectedDays.push('tuesday');
    if(this.ResourceReduction.wednesday) this.selectedDays.push('wednesday');
    if(this.ResourceReduction.thursday) this.selectedDays.push('thursday');
    if(this.ResourceReduction.friday) this.selectedDays.push('friday');
    if(this.ResourceReduction.saturday) this.selectedDays.push('saturday');
    if(this.ResourceReduction.sunday) this.selectedDays.push('sunday');
  }

  onDaysChange()
  {
    this.ResourceReduction.monday = this.selectedDays.includes('monday');
    this.ResourceReduction.tuesday = this.selectedDays.includes('tuesday');
    this.ResourceReduction.wednesday = this.selectedDays.includes('wednesday');
    this.ResourceReduction.thursday = this.selectedDays.includes('thursday');
    this.ResourceReduction.friday = this.selectedDays.includes('friday');
    this.ResourceReduction.saturday = this.selectedDays.includes('saturday');
    this.ResourceReduction.sunday = this.selectedDays.includes('sunday');

    this.DoValidCheck();
  }

  toggleDay(day: string)
  {
    const index = this.selectedDays.indexOf(day);

    if(index > -1)
    {
      this.selectedDays.splice(index, 1);
    }
    else
    {
      this.selectedDays.push(day);
    }

    this.onDaysChange();
  }

  updateData()
  {
    if ([this.DoDateValidCheck(), this.DoValidCheck(), this.DoAdjustmentCheck(), this.DoDateCheck()].every(x => x == true))
    {
      this.ResourceReduction.resourcetoreduce = this.chosenResource;
      this.ResourceReduction.resourceid = this.chosenResource.resourceId;

      if(this.id=="0")
      {
        this.http.post<resourcereductions>(bmxurl + "/ResourceReduction", this.ResourceReduction).subscribe(response => {
          this.httpResponse = response
          if(this.httpResponse.succeeded == true)
          {
            this.messageService.add({severity:'success', summary:'Saved', detail:'Resource Adjustment successfully created'});
            this.returnToList();
          }
        }, error => {
          this.messageService.add({severity:'error', summary:'Not Saved', detail:error.messages[0]});
        })
      }
      else
      {
        this.ResourceReduction.disabled = false;

        this.http.put<resourcereductions>(bmxurl + "/ResourceReduction", this.ResourceReduction).subscribe(response => {
          this.httpResponse = response
          if(this.httpResponse.succeeded == true)
          {
            this.messageService.add({severity:'success', summary:'Saved', detail:'Resource Adjustment successfully updated'});
            this.returnToList();
          }
        }, error => {
          this.messageService.add({severity:'error', summary:'Not Saved', detail:error.messages});
        })
      }
    }
  }

  DoDateCheck()
  {
    let AllValid = true;

    let startdatestring = "";

    startdatestring = this.stringifyDate(new Date(this.newStartDate).getFullYear(), new Date(this.newStartDate).getMonth(), new Date(this.newStartDate).getDate(), Number(this.resourceSelectedStartTimeHours), Number(this.resourceSelectedStartTimeMins));

    this.ResourceReduction.startdate = startdatestring;

    let enddatestring = "";

    enddatestring = this.stringifyDate(new Date(this.newEndDate).getFullYear(), new Date(this.newEndDate).getMonth(), new Date(this.newEndDate).getDate(), Number(this.resourceSelectedEndTimeHours), Number(this.resourceSelectedEndTimeMins));

    this.ResourceReduction.enddate = enddatestring;

    if(this.ResourceReduction.startdate > this.ResourceReduction.enddate)
    {
      AllValid = false;
      this.resourceDateLoginValid = false;
    }
    else
    {
      this.resourceDateLoginValid = true;
    }

    return AllValid
  }

  stringifyDate(Year: number, Month: number, Day: number, Hour: number, Mins: number): string
  {
    let returnString = "";

    returnString = Year + "-" +  ('00' + (Month + 1).toString()).slice(-2) + "-" +  ('00' + Day.toString()).slice(-2)+ "T" + ('00' + Hour.toString()).slice(-2) + ":" + ('00' + Mins.toString()).slice(-2) + ":00.0000Z";

    return returnString;
  }

  DoValidCheck()
  {
    let AllValid = true;

    if(this.ResourceReduction.name == null || this.ResourceReduction.name == "")
    {
      AllValid = false;
      this.resourceNameValid = false;
    }
    else
    {
      this.resourceNameValid = true;
    }

    if(this.ResourceReduction.reductionbasedonday && this.selectedDays.length == 0)
    {
      AllValid = false;
      this.resourceDaysValid = false;
    }
    else
    {
      this.resourceDaysValid = true;
    }

    return AllValid;
  }

  //Separate from DoValidCheck, which also runs on every keystroke in the name field - that
  //would flag "choose a resource" while someone is still typing the name. Only run on save.
  DoAdjustmentCheck()
  {
    let AllValid = true;

    if(this.chosenResource == null || this.chosenResource.resourceId == null)
    {
      AllValid = false;
      this.resourceChosenValid = false;
    }
    else
    {
      this.resourceChosenValid = true;
    }

    let adjustment = this.ResourceReduction.adjustmentamount;

    if(adjustment == null || adjustment < 0 || adjustment > this.adjustmentMax())
    {
      AllValid = false;
      this.adjustmentValid = false;
    }
    else
    {
      this.adjustmentValid = true;
    }

    return AllValid;
  }

  DoDateValidCheck()
  {
    let AllValid = true;

    if(this.ResourceReduction.startdate == null)
    {
      AllValid = false;
      this.resourceStartDateValid = false;
    }
    else
    {
      this.resourceStartDateValid = true;
    }

    if(this.ResourceReduction.enddate == null)
    {
      AllValid = false;
      this.resourceEndDateValid = false;
    }
    else
    {
      this.resourceEndDateValid = true;
    }

    return AllValid;
  }

  //Back to the Resource Reductions tab, not the Resource Closings one the list opens on.
  returnToList()
  {
    this.router.navigate(['/resourceclosings'], { queryParams: { tab: 'reductions' } });
  }
}
